import { z } from 'zod';
import { COOKIE_CONSENT_VERSION } from '../config/cookie-consent.config';


export const cookieConsentSchema = z.object({
    version  : z.literal(COOKIE_CONSENT_VERSION),
    necessary: z.literal(true),
    analytics: z.boolean(),
});
